export default "__VITE_ASSET__CGEk8Lou__"